import React from 'react'

const Security = () => {
    return (
        <div>
            <section class="inner-banner">
                <div class="thm-container">
                    <h2> Product Details </h2>
                    <div class="breadcumb">
                        <a href="/">Automation Solution</a>
                        <i class="fa fa-angle-right"></i>
                        <span>Building Solution</span>
                        <i class="fa fa-angle-right"></i>
                        <span>Security Systems</span>
                    </div>
                </div>
            </section>
            <div className='container py-4'>
                <div className='row d-flex' style={{ margin: "80px 0px" }}>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <img src='/img/security.png' width={400}></img>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <h2 style={{ textDecoration: "underline" }}>Security Systems:</h2>
                        <p className="mbot25">
                            We deliver robust security systems, including surveillance, access control, and alarms. Our integrated solutions protect your assets and enhance safety, giving you peace of mind in industrial and building environments.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Security
